document.addEventListener("alpine:init", () => {
    Alpine.data("accordion", () => ({
        accordion: null,
        init() {},
    }));
});
